import { useEffect } from "react";
import Story from "./Story";
import AboutHerosection from "./AboutHerosection";
import Capabilities from "./Capabilities";
import Testamonial from "../HomePage/Testamonial";
import NewsLetter from "../HomePage/NewsLetter";

const AboutPage = () => {
  useEffect(() => {
    const metaTag = document.querySelector("meta[name='description']");
    document.title = "About John Bostjancic | CFO & Financial Strategy Expert";

    if (metaTag) {
      document.head.appendChild(metaTag);
      metaTag.setAttribute(
        "content",
        "Learn about John Bostjancic, CFO with 30+ years in finance, healthcare, and medical devices, driving growth, efficiency, and success."
      );
    }

    let linkTag = document.querySelector("link[rel='canonical']");
    if (linkTag) {
      linkTag.setAttribute("href", "https://johnbostjancic.co/about-us");
    } else {
      linkTag = document.createElement("link");
      (linkTag as HTMLLinkElement).rel = "canonical";
      (linkTag as HTMLLinkElement).href = "https://johnbostjancic.co/about-us";
    }

    if (!document.head.contains(linkTag)) {
      document.head.appendChild(linkTag);
    }

    //keyWords
    let keyWordTag = document.querySelector("meta[name='keywords']");
    if (!keyWordTag) {
      keyWordTag = document.createElement("meta");
      (keyWordTag as HTMLMetaElement).name = "keywords";
      document.head.appendChild(keyWordTag);
    }
    keyWordTag.setAttribute("content", "About John Bostjancic");

  }, []);

  return (
    <>
      <div className="overflow-hidden lg:overflow-visible">
        <AboutHerosection />
        <Story />
        <Capabilities />
        <Testamonial />
        {/* <Teams /> */}
        <NewsLetter />
      </div>
    </>
  );
};

export default AboutPage;
